import React, { Component } from 'react';
import {
  Col,
  Row,
  FormGroup,
  ControlLabel,
  FormControl,
  Glyphicon,
  Button
} from 'react-bootstrap';

import {
  grades,
  terms,
  unitOptions,
  scienceRequirements,
  nonScienceRequirements,
  nonGpaRequirements,
  optionalRequirements,
  statusTypes,
  upgradeRequirements,
  PROGRAM_ADN,
  combinedPTOptions
} from '../config/constants';
import FormSectionStatus from './FormSectionStatus';

class Course extends Component {
  constructor(props){
    super(props);
    Course.getValidationState = Course.getValidationState.bind(this);
    this.handleNameChange = this.handleNameChange.bind(this);
    this.handleGradeChange = this.handleGradeChange.bind(this);
    this.handleUnitChange = this.handleUnitChange.bind(this);
    this.handleTermChange = this.handleTermChange.bind(this);
    this.handleYearChange = this.handleYearChange.bind(this);
    this.handleChanges = this.handleChanges.bind(this);
    this.handleRemoveCourse = this.handleRemoveCourse.bind(this);
    this.handleRequirementChange = this.handleRequirementChange.bind(this);
    this.toggleRequirement = this.toggleRequirement.bind(this);
    this.handleRepeatChange = this.handleRepeatChange.bind(this);
  }

  static getValidationState(){
    return 'success';
  }

  handleNameChange(e){
    const updates = { name: e.target.value };
    this.props.onUpdateCourse(this.props.id, updates);
  }

  handleGradeChange(e){
    const updates = { grade: e.target.value };
    this.props.onUpdateCourse(this.props.id, updates);
  }

  handleUnitChange(e){
    const updates = { units: e.target.value };
    this.props.onUpdateCourse(this.props.id, updates);
  }

  handleTermChange(e){
    const updates = { term: e.target.value };
    this.props.onUpdateCourse(this.props.id, updates);
  }

  handleYearChange(e){
    const updates = { year: e.target.value };
    this.props.onUpdateCourse(this.props.id, updates);
  }

  toggleRequirement(key){
    let updates = {};
    updates[key] = !this.props[key];
    this.props.onUpdateCourse(this.props.id, updates);
  }

  handleRequirementChange(e) {
    let updates = { requirement: e.target.value };
    this.props.onUpdateCourse(this.props.id, updates);
  }

  handleRepeatChange(e) {
    const updates = { repeat: e.target.checked };
    this.props.onUpdateCourse(this.props.id, updates);
  }

  render() {
    const { validationState } = this.props;
    const space = ' ';
    const repeatPossible = this.props.programId === PROGRAM_ADN && Object.keys(scienceRequirements).find(key => key === this.props.requirement);

    const getGradeOptions = () => {
      return grades.map((grade) => {
        return (
          <option key={grade} value={grade}>{grade}</option>
        );
      });
    };

    const getTermOptions = () => {
      return Object.keys(terms).map((term) => {
        return (
          <option key={term} value={term}>{terms[term]}</option>
        )
      });
    };

    const getUnitOptions = () => {
      return unitOptions.map((units) => {
        return (
          <option key={units} value={units}>{units}</option>
        )
      });
    };

    const getOptionsFromObject = (options) => {
      return Object.keys(options).map(option => {
        return(
          <option key={option} value={option}>{options[option]}</option>
        )
      });
    };

    const getSectionStatus = () => {
      return validationState.section.status === 'success' ? null : <FormSectionStatus {...validationState.section}/>;
    };

    const getRequirementOptions = () => {
      return this.props.programId === PROGRAM_ADN ? (
        <FormControl componentClass="select"
                     value={this.props.requirement}
                     placeholder=""
                     onChange={this.handleRequirementChange}>
          <option value="">Select One...</option>
          <option disabled>--- Science ---</option>
          {getOptionsFromObject(scienceRequirements)}
          <option disabled>--- Non-Science ---</option>
          {getOptionsFromObject(nonScienceRequirements)}
          <option disabled>--- Non-GPA ---</option>
          {getOptionsFromObject(nonGpaRequirements)}
          <option disabled>--- Optional ---</option>
          {getOptionsFromObject(optionalRequirements)}
          <option disabled>--- Upgrade Requirements ---</option>
          {getOptionsFromObject(upgradeRequirements)}
        </FormControl>
      ) :
      (
        <FormControl componentClass="select"
                     value={this.props.requirement}
                     placeholder=""
                     onChange={this.handleRequirementChange}>
          <option value="">Select One...</option>
          <option disabled>--- PT Requirements ---</option>
          {getOptionsFromObject(combinedPTOptions)}
        </FormControl>
      )
    };

    return (
      <fieldset className="course-form">
        <Row>
        <Col md={4}>
          <FormGroup controlId={'course-' + this.props.id + '-name'}
                     validationState={validationState.name}>
            <ControlLabel>
              Course Name
            </ControlLabel>
            {space}
            <FormControl type="text"
                         value={this.props.name}
                         placeholder="Course Name"
                         onChange={this.handleNameChange}/>
            <FormControl.Feedback />
          </FormGroup>
        </Col>
        <Col md={2} xs={6}>
          <FormGroup controlId={'course-' + this.props.id + '-grade'}
                     validationState={validationState.grade}>
            <ControlLabel>
              Grade
            </ControlLabel>
            {space}
            <FormControl componentClass="select"
                         value={this.props.grade}
                         placeholder=""
                         onChange={this.handleGradeChange}>
              <option value=""></option>
              {getGradeOptions()}
            </FormControl>
          </FormGroup>
        </Col>
        <Col md={2} xs={6}>
          <FormGroup controlId={'course-' + this.props.id + '-units'}
                     validationState={validationState.units}>
            <ControlLabel>
              Units
            </ControlLabel>
            {space}
            <FormControl componentClass="select"
                         value={this.props.units}
                         placeholder=""
                         onChange={this.handleUnitChange}>
              <option value=""></option>
              {getUnitOptions()}
            </FormControl>
          </FormGroup>
        </Col>
        <Col md={2} xs={6}>
          <FormGroup controlId={'course-' + this.props.id + '-term'}
                     validationState={validationState.term}>
            <ControlLabel>
              Term
            </ControlLabel>
            {space}
            <FormControl componentClass="select"
                         placeholder = ""
                         value={this.props.term}
                         onChange={this.handleTermChange}>
              <option value="">Select</option>
              {getTermOptions()}
            </FormControl>
          </FormGroup>
        </Col>
        <Col md={2} xs={6}>
          <FormGroup controlId={'course-' + this.props.id + '-year'}
                     validationState={validationState.year}>
            <ControlLabel>
              Year
            </ControlLabel>
            {space}
            <FormControl type="text"
                         placeholder = "Year"
                         value={this.props.year}
                         onChange={this.handleYearChange}/>
          </FormGroup>
        </Col>
        </Row>
        <Row>
        <Col md={6}>
          <FormGroup controlId={'course-' + this.props.id + '-requirement'}
                     validationState={validationState.requirement}>
            <ControlLabel>
              Requirement
            </ControlLabel>
            {space}
            {getRequirementOptions()}
          </FormGroup>
        </Col>
        <Col md={3}>
          {repeatPossible &&
          <FormGroup controlId={'course-' + this.props.id + '-repeat'}
                     validationState={statusTypes.SUCCESS}>
            <ControlLabel>
              Repeat Attempt
            </ControlLabel>
            <div>
              <input
                type="checkbox"
                checked={!!this.props.repeat}
                onChange={this.handleRepeatChange}
              />{' '}
              <span>This is a repeat attempt and not my final grade (exclude from GPA).</span>
            </div>
          </FormGroup>
          }
        </Col>
        <Col md={3} style={{justifyContent: 'flex-end', display: 'flex', paddingTop: '25px'}}>
          <Button bsStyle="danger"
                  onClick={this.handleRemoveCourse}>
            <Glyphicon glyph="trash"/>
            {space} Remove Course
          </Button>
        </Col>
        </Row>
        <div className="clearfix"></div>
        {getSectionStatus()}
      </fieldset>
  );
  };

  handleChanges(updates){
    this.props.onUpdateCourse(this.props.id, updates);
  }

  handleRemoveCourse(e){
    e.preventDefault();
    this.props.onRemoveCourse(this.props.id);
  }
}

export default Course;